/* eslint-disable @next/next/no-img-element */
import { IconButton } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import { getAssets } from "@unisearch/helpers";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useEffect } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { useMediaQuery } from "react-responsive";
import styles from "./recent_post.module.scss";

const RecentPost = ({ recentPost }) => {
  const { asPath, query } = useRouter();
  const isMobile = useMediaQuery({
    query: "(max-width: 991px)",
  });
  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  useEffect(() => {
    if (isMobile) {
      setOpen(false);
    }
  }, [isMobile]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.heading}>
        <span>Recent Posts</span>
        {isMobile && (
          <IconButton disableRipple>
            {open ? (
              <FiChevronUp onClick={handleClick} />
            ) : (
              <FiChevronDown onClick={handleClick} />
            )}
          </IconButton>
        )}
      </div>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <ul className={styles.list_group_wrapper}>
          {recentPost &&
            recentPost?.results?.length > 0 &&
            recentPost?.results?.map((item, i) => (
              <li
                key={i}
                className={
                  item.questionLink === query.post_slug ? styles.active : ""
                }
              >
                <Link legacyBehavior href={`/forum/${item.questionLink}`}>
                  <a className={styles.list_wrapper}>
                    <div className={styles.img_wrapper}>
                      <img
                        src={item?.profileImage ?? getAssets(item.image)}
                        alt={item?.userName}
                      />
                    </div>
                    <div>
                      <h4 className={styles.title}>{item?.userName}</h4>
                      <p className={styles.text}>{item?.questionTitle}</p>
                    </div>
                  </a>
                </Link>
              </li>
            ))}
        </ul>
      </Collapse>
    </div>
  );
};

export default RecentPost;
